module.exports = __webpack_public_path__ + "img/36.a885aa7b.png";